import { useState } from "react";
import { Button } from 'antd';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { useTheme } from '../App'; // Import the theme hook

function RouteCopyButton({ route }) {
  const [copied, setCopied] = useState(false);
  const { theme } = useTheme();

  const handleCopyRoute = () => {
    navigator.clipboard.writeText(route).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <Button
      type="text"
      icon={copied ? <CheckOutlined style={{ color: theme.success }} /> : <CopyOutlined />}
      onClick={handleCopyRoute}
      style={{ 
        padding: '0 4px',
        color: copied ? theme.success : theme.primary,
        transition: 'all 0.2s ease',
      }}
    >
      {copied ? 'Copied!' : 'Copy'}
    </Button>
  );
}

export default RouteCopyButton;